import { Button } from "@/components/ui/button";
import { ArrowLeft, Shield } from "lucide-react";

interface PageHeaderProps {
  onBack?: () => void;
  customBackText?: string;
  title: string;
  subtitle?: string;
  organizationName?: string;
  className?: string;
}

export function PageHeader({ 
  onBack, 
  customBackText = "Back", 
  title,
  subtitle,
  organizationName,
  className = "" 
}: PageHeaderProps) {

  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      window.history.back();
    }
  };

  return (
    <div className={`bg-white border-b border-gray-200 shadow-sm ${className}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-6">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 bg-gradient-to-br from-purple-600 to-purple-500 rounded-lg flex items-center justify-center shadow-lg">
              <Shield className="w-7 h-7 text-white" />
            </div>
            <div>
              <h1 className="page-title text-2xl font-bold text-gray-900">{title}</h1>
              <p className="text-gray-600">{subtitle || organizationName || 'Smart Care Audits Platform'}</p>
            </div>
          </div>
          <div className="flex items-center space-x-4">
            {onBack && (
              <Button 
                variant="outline" 
                onClick={handleBack}
                className="flex items-center gap-2 text-purple-600 border-purple-200 hover:bg-purple-50"
                data-testid="button-back"
              >
                <ArrowLeft className="w-4 h-4" />
                {customBackText}
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}